import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-edit\">\r\n    <path d=\"M249.6 838.4c19.2 0 38.4-6.4 57.6-19.2h6.4L134.4 640v6.4c-12.8 19.2-19.2 38.4-19.2 57.6l-64 198.4 198.4-64z m640-716.8L832 64c-32-32-83.2-32-115.2 0l-57.6 57.6L832 294.4l57.6-57.6c32-32 32-83.2 0-115.2zM774.4 352L601.6 179.2 198.4 582.4l172.8 172.8L774.4 352zM0 960h1024v64H0v-64z\" fill=\"#1aa5ed\" p-id=\"17833\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol